export const ADD_LOAD_OBJECT_DEVICES = "ADD_LOAD_OBJECT_DEVICES"; // 添加负荷对象设备
export const DELETE_LOAD_OBJECT_DEVICES = "DELETE_LOAD_OBJECT_DEVICES"; // 删除负荷对象设备
export const INIT_LOAD_OBJECT_DEVICES = "INIT_LOAD_OBJECT_DEVICES"; // 删除负荷对象设备

/**
 * 添加选中设备列表
 * @param data
 */
export const addDevicesList = (devicesList) => {
    return {
        type: ADD_LOAD_OBJECT_DEVICES,
        devicesList: devicesList,
    }
}
/**
 * 删除选中设备列表
 * @param data
 * @returns {{devicesList: *, type: *}}
 */
export const deleteDevicesList = (devicesList) => {
    return {
        type: DELETE_LOAD_OBJECT_DEVICES,
        devicesList: devicesList
    }
}
/**
 * 初始化选中设备列表
 */
export const initDevicesList = (devicesList) => {
    return {
        type: INIT_LOAD_OBJECT_DEVICES,
        devicesList: devicesList
    }
}
